// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

export function useShipMethods(props?) {
  return useRequestQuery(
    [t.SHIP_METHODS],
    { method: 'get', url: 'ship-methods' },
    {
      select: (res) => res.data.ship_methods,
      defaultData: [],
      ...props,
    },
  );
}

export function useShipMethod(id, props?) {
  return useRequestQuery(
    [t.SHIP_METHOD, id],
    { method: 'get', url: `ship-methods/${id}` },
    {
      select: (res) => res.data.ship_method,
      defaultData: {},
      enabled: !!id,
      ...props,
    },
  );
}

export function useCreateShipMethod(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (values) => apiRequest.post('ship-methods', values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIP_METHODS);
      },
      ...props,
    },
  );
}

export function useEditShipMethod(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([id, values]) => apiRequest.put(`ship-methods/${id}`, values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIP_METHODS);
        queryClient.invalidateQueries(t.SHIP_METHOD);
      },
      ...props,
    },
  );
}

export function useDeleteShipMethod(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    (id) => apiRequest.delete(`ship-methods/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(t.SHIP_METHODS);
      },
      ...props,
    },
  );
}